<template>
    <el-dialog :visible.sync="dialogFormVisible" class="edit_form">
        <el-form :model="selected_transaction" label-width="120px">
            <el-form-item label="Категорія">
                <el-select v-model="selected_transaction.category.id">
                    <el-option v-for="item in categories" :key="item.id" :label="item.display_name" :value="item.id"/>
                </el-select>
            </el-form-item>
            <el-form-item label="Опис" >
                <el-input type="textarea" v-model="selected_transaction.description"></el-input>
            </el-form-item>
            <el-form-item >
                <el-checkbox v-model="selected_transaction.planned_transaction" label="Запланована транзакція" border></el-checkbox>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeForm()">Відміна</el-button>
            <el-button type="primary" @click="saveForm()">Зберегти</el-button>
        </span>
    </el-dialog>
</template>
<script>

export default {
    props: ['selected_transaction', 'categories', 'dialogFormVisible'],
    methods: {
        async saveForm() {
            this.$emit('save')
        },
        closeForm() {
            this.$emit('close')
        }
    }
}
</script>
<style scoped>
  .el-row {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .edit_form {
    text-align: left;
  }

</style>